import { render } from "./DossierJour.vue?vue&type=template&id=b462be9c"
import script from "./DossierJour.vue?vue&type=script&lang=js"
export * from "./DossierJour.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__